import { Directive, Host, HostListener, Optional, Self } from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";

@Directive({
    selector: "ng-select",
    standalone: false
})
export class LoveItNgSelectDirective {
  constructor(@Host() @Self() @Optional() public hostSelectComponent: NgSelectComponent) {}

  @HostListener("change", ["$event"])
  onChange() {
    if (this.hostSelectComponent.multiple) {
      this.hostSelectComponent.filter("");
    }
  }
}
